import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-4 text-xs"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "mt-4 mb-2 text-xs text-gray-500 uppercase" }, " Recommendations: ", -1)
const _hoisted_3 = { class: "" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_maneuver_card = _resolveComponent("maneuver-card")

  return (
      _ctx.recommendation.corrections &&
      _ctx.recommendation.corrections[_ctx.recommendation.maneuver.reason]
    )
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _createVNode(_component_maneuver_card, {
          title: _ctx.recommendation.corrections[_ctx.recommendation.maneuver.reason].title,
          maneuver: _ctx.recommendation.maneuver
        }, null, 8, ["title", "maneuver"]),
        _hoisted_2,
        _createVNode("ul", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recommendation.corrections[
          _ctx.recommendation.maneuver.reason
        ].corrections, (correction, index) => {
            return (_openBlock(), _createBlock("li", { key: index }, [
              (!correction.detail || correction.detail === '')
                ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(correction.correction), 1))
                : (_openBlock(), _createBlock("div", _hoisted_5, "Study " + _toDisplayString(correction.detail), 1))
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}